import defined from "../Core/defined.js";
import RequestType from "../Core/RequestType.js";
import createTaskProcessorWorker from "./createTaskProcessorWorker.js";
import EV_IndexedDBProvider from "../EMExtensions/EV_IndexedDBProvider.js";

var iDBSaveprovider = undefined;

function crateIDBCallbackFunc(state) {
  var postMessage = self.webkitPostMessage || self.postMessage;
  try {
    postMessage({
      workerType: RequestType.TILES3D
    });
  } catch (e) {
    postMessage({});
  }
}

function save3DTileArraybuffer(parameters, transferableObjects) {
  var indexedDB = parameters.indexedDB;
  var c3DTilePack = parameters.taskData;
  c3DTilePack.workerTaskID = parameters.workerTaskID;
  if (!defined(iDBSaveprovider)) {
    iDBSaveprovider = new EV_IndexedDBProvider(indexedDB);
    iDBSaveprovider.createIDB("EVIDB", 1, ["model", "imagery", "terrain", "3DTile"], crateIDBCallbackFunc);
  } else {
    if (defined(iDBSaveprovider.iDB)) {
      iDBSaveprovider.save3DTileArrayBuffer("EVIDB", 1, "3DTile", c3DTilePack,crateIDBCallbackFunc);
    }
  }
}

export default createTaskProcessorWorker(
  save3DTileArraybuffer
);